import 'babel-polyfill';
import './main.scss';
import './fonts.scss';

import React from 'react';
import ReactDOM from 'react-dom';

import asyncComponent from './asyncComponent';

const App = asyncComponent(() => import('./App'));
// const ContentContainer = asyncComponent(() => import('./web/containers/ContentContainer'));
const LearningExperience = asyncComponent(() => import('./lex/index'));
const LearningExperienceDetail = asyncComponent(() => import('./lex/containers/LexContainer'));
const AutoCloseContainer = asyncComponent(() => import('./web/containers/AutoCloseContainer'));

import {Route, HashRouter as Router} from 'react-router-dom';

import {createStore, applyMiddleware, compose, combineReducers} from 'redux';
import createSagaMiddleware from 'redux-saga';
import {Provider} from 'react-redux';

// i18n
import {IntlProvider, addLocaleData} from 'react-intl';
import locale_en from 'react-intl/locale-data/en';

import message_en from './translation/en.json';

import {urlReducer} from './web/reducers/url.reducer';
import {loginReducer} from './web/reducers/login.reducer';
import {contentReducer} from './core/reducers/content.reducer';
import {authReducer} from './core/reducers/auth.reducer';
import {homeReducer} from './core/reducers/home.reducer';
import {errorReducer} from './core/reducers/error.reducer';
import {lexDetailReducer} from './lex/store/reducers/lexDetail.reducer';
import {lexCntDetailReducer} from './lex/store/reducers/lexCntDetail.reducer';
import {lexModalReducer} from './lex/store/reducers/lexModal.reducer';
import {lexEnrolledReducer} from './lex/store/reducers/lexEnrolled.reducer';
import {lexLangLaunchReducer} from './lex/store/reducers/lexLangLaunch.reducer';
import {miscellaneousReducer} from './lex/store/reducers/miscellaneous.reducer';
import {lexStateMaintainReducer} from './lex/store/reducers/LexStateMaintain.reducer';
import {favouriteReducer} from './lex/store/reducers/lexFavourite.reducer';
import {lexGenCopyLinkReducer} from './lex/store//reducers/lexGenCopyLink.reducer';
import {lexLoginReducer} from './lex/store/reducers/lexLogin.reducer';
import {licenseModeReducer} from './lex/store/reducers/lexLicenseMode.reducer';
import {lexExamReducer} from './lex/store/reducers/lexExam.reducer';
import {lexLoginDSPReducer} from './lex/store//reducers/lexLoginDSP.reducer';
import {lexCertEnrollAvailCreditReducer} from './lex/store//reducers/lexCertEnrollAvailCredit.reducer';
import {lexRecommandedLearningReducer} from './lex/store//reducers/lexRecommandedLearning.reducer';
import rootSaga from './web/rootSaga';


const sagaMiddleware = createSagaMiddleware();
let complSts = '', progMeasure = '';
const queryString = window.location.search;
const params = new URLSearchParams(queryString);
const lpId = params.get('lpId');

window.isUp = true;

addLocaleData([...locale_en]);

const frameArr = [];
window.parentWrap = {};

function receiveMessage(event) {
    // rka8: below is check for 3dxu / catalog
    // else block is for backward compatability
    let flag = false;
    if (event.data.response === 'yes') {
        window.parentWrap = event.source;
        window.lmsUrl = event.data.lmsUrl;
    } else if (event.data === 'yes') {
        window.parentWrap = event.source;
        window.lmsUrl = event.origin;
    } else if (event.data === 'reload') {
        console.log('for reload');
        window.location.reload();
    } else if (event.data.method === 'SetValue') {
        if (event.data.varname === 'cmi.completion_status') {
            complSts = event.data.varvalue.toLowerCase();
        }
        if (event.data.varname === 'cmi.progress_measure') {
            progMeasure = event.data.varvalue;
        }
        if (complSts !== '' && progMeasure !== '') {
            flag = true;
        }
        if (flag) {
            let sts = '';
            if (complSts === 'not started') {
                sts = '0';
            } else if (complSts === 'incomplete' || complSts === 'in progress' || complSts === 'inprogress') {
                sts = '1';
            } else {
                sts = '2';
            }
            fetch(`${window.location.origin}/CompanionManager/rest/up/trackingService/setLpTracking`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    lpId: lpId,
                    status: sts,
                    comPer: progMeasure})
            })
            .then(response => response.json())
            .then(data => {
                console.log(data);
            });
        }
    }
}

window.addEventListener('message', receiveMessage, false);

function findAPI(win) {
    let temp;
    if (window !== win) {
        win.postMessage('isWrap', '*');
    }
    for (let i = 0; i < win.frames.length; i++) {
        win.frames[i].postMessage('isWrap', '*');
        // window.frames[i].addEventListener('message', receiveMessage, false);
        if (win.frames[i].frames && win.frames[i].frames.length > 0) {
            frameArr.push(win.frames[i].frames);
        }
    }
    if (frameArr[0]) {
        temp = frameArr.shift();
        findAPI(temp);
    }
}

findAPI(window.top);

// dev tools middleware
const reduxDevTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();

// create a redux store with our reducer above and middleware
const store = createStore(
    combineReducers({
        urlReducer,
        loginReducer,
        contentReducer,
        errorReducer,
        lexDetailReducer,
        lexCntDetailReducer,
        lexModalReducer,
        lexEnrolledReducer,
        lexLangLaunchReducer,
        miscellaneousReducer,
        lexStateMaintainReducer,
        favouriteReducer,
        licenseModeReducer,
        lexLoginReducer,
        authReducer,
        homeReducer,
        lexExamReducer,
        lexGenCopyLinkReducer,
        lexLoginDSPReducer,
        lexCertEnrollAvailCreditReducer,
        lexRecommandedLearningReducer
    }),
    reduxDevTools,
    compose(applyMiddleware(sagaMiddleware))
);

// const messages = {
//     'en': message_en
// };
// const language = navigator.language.split(/[-_]/)[0];

// run the saga
sagaMiddleware.run(rootSaga);

// basename="/CompanionManager/up"
ReactDOM.render(
    <IntlProvider locale={'en'} messages={message_en}>
    <Router>
        <Provider store={store}>
            <div>
                <Route exact path='/' component={App} />
                {/* <Route path='/content' component={ContentContainer} /> */}
                <Route path='/lp' component={LearningExperience} />
                <Route path='/lp-content' component={LearningExperienceDetail} />
                <Route exact path="/close" component={AutoCloseContainer} />
            </div>
        </Provider>
    </Router>
    </IntlProvider>,
    document.getElementById('app')
);

// <div>
// <Route exact path='/' component={App} />
// <Route path='/some' component={Some} />
// </div>
// <Route exact path='/' component={App} />
// <Route path='/some' component={Some} />
// registerServiceWorker();
